export enum UserRole {
    ADMIN = 1,
    CLIENT = 2,
    LAWYER = 3,
    CONTENT_MANAGER = 4,
    BOT = 5,
}